import { createSelector } from '@ngrx/store';
import { RedirectMessageState } from 'sp-mark/feature-modules/redirect-message/redux/redirect-message.reducers';
import { AppState } from 'sp-mark/redux';

export const selectFeature = (appState: AppState) => appState.redirectMessage;

export const selectCounter = createSelector(
  selectFeature,
  (state: RedirectMessageState) => state ? state.counter : undefined
);

export const selectSellResponse = createSelector(
  selectFeature,
  (state: RedirectMessageState) => state ? state.sellResponse : undefined
);

export const selectSellResponseStatus = createSelector(
  selectFeature,
  (state: RedirectMessageState) => state ? state.sellResponseStatus : undefined
);
